import { render, staticRenderFns } from "./BnSideBarNav.vue?vue&type=template&id=a9cec44e&scoped=true&"
import script from "./BnSideBarNav.vue?vue&type=script&lang=js&"
export * from "./BnSideBarNav.vue?vue&type=script&lang=js&"
import style0 from "./BnSideBarNav.vue?vue&type=style&index=0&id=a9cec44e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9cec44e",
  null
  
)

export default component.exports